<app-header-nav-bar>
    <app-header-nav-snap-output style="width:20%;" [isAddClientDetails]="true" [snapNameNavHeader]="snapHeaderName"
        [ImageURL]="ImageURL"></app-header-nav-snap-output>
    <app-header-section-list style="width:80%;" [clientSnapDetails]="clientDetails.clientDetails"></app-header-section-list>
    <app-header-home [moduleName]="'snapshot'" style="width:20%;" [additionalCheck]="additionalCheckList" (OnSettingsSel)="OnSettingsSel($event)"></app-header-home>
</app-header-nav-bar>

<div class="leftPanelandOutputArea">
    <app-leftpanel-snapshot class="expandLeftPanel" [onItemClick]="handleCheckboxClick" [moduleLists]="moduleList"
        (showOutput)="ShowOutput()" (snapNameNavHeader)="snapHeaderNameFun($event)" (BindImageURL)="brandLogo($event)"
        (valueChange)="toggleLeftPanel($event)" (selectedType)="selectedTypeFun($event)"
        (baseValuesChanged)="onBaseValuesChanged($event)" (isLoadSelection)="LoadSelection($event)"
        [selectedScenarioData]="selectedScenarioData" [dataArray]="dataArray" [output_data]="output_data"
        [isSavedScenarioSelected]="isSavedScenarioSelected" [selectedBrandFromConfig]="selectedBrandFromConfig"
        (additionalList)="additionalCheck($event)"></app-leftpanel-snapshot>

    <div class="output-view DN" id="output-div">
        <div class="infoRibbon summaryPanel" #summaryText DocumentClick (DocumentClicked)="closeSelectionSummary()">
            <!--selection summary Panel-->

            <div class="InfoRibbonText">
                <div class="InforRibbonTextValues" #inforRibbon></div>
            </div>
            <div class="InfoRibbonTextCompleteSummary DN">
                <div class="InforRibbonEntireSummary"></div>
            </div>

            <div class="InfoCollapse" (click)="selectionSummaryBlock()">
                <div class="arrowToggle info-collapse-icon"></div>
            </div>

            <div class="downloadExport" DocumentClick (DocumentClicked)="closeDropdown()" (click)="toggleContainer()">
                <div class="download"></div>
            </div>
        </div>
        <div class="polygon showPanel" *ngIf="showContainer">
            <div class="polygon-icon poly-icon"></div>
        </div>
        <div class="setting-container showPanel" *ngIf="showContainer">
            <div class="setting-blocks editablePPTSettings" *ngIf="editablePPT" (click)="editablePPTClicked()">
                <div class="setting-block-icon ppt-icon"></div>
                <div class="setting-block-name">PPT (Editable)</div>
            </div>
            <div class="setting-blocks screengrabPPTSettings" *ngIf="staticPPT" (click)="screengrabPPTClicked()">
                <div class="setting-block-icon ppt-icon"></div>
                <div class="setting-block-name">PPT (Static)</div>
            </div>
            <div class="setting-blocks excelexportSettings" *ngIf="excelExport" (click)="excelexportClicked()">
                <div class="setting-block-icon excel-icon"></div>
                <div class="setting-block-name">Excel</div>
            </div>
        </div>
        <!-- ------------------------------------------------------     -->
        <div class="extraSelections">
            <!-- <div class="sigIndexArea">
                <div class="sigArea initialSelected" >Sig</div>
                <div class="indexArea" >Index</div>
            </div> -->

            <div class="sigIndexArea">
                <div class="sigArea">
                    <!-- <div class="sigArea" > -->
                    <div style="display:flex;position:relative;width:100%;height:100%;align-items: center;"
                        [ngClass]="{'initialSelected': isSigSelected}" (click)="onSigType($event);select('sig',$event)">
                        <p style="width:80%;text-align: center; font-size: 0.75rem;">Sig</p>
                        <img *ngIf="significanceTypes.length > 1"
                            src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg" alt="" class="icon-sig">
                    </div>
                    <div *ngIf="sigTypeDropdown && significanceTypes.length > 1" class="a" DocumentClick
                        (DocumentClicked)="closeSigDropdown()">
                        <div *ngFor="let type of significanceTypes" class="dropdown-values-sig"
                            (click)="onSigTypeClick(type,$event)">
                            <div style="padding-top:3%"><input type="radio" name="type" [value]="type.value"
                                    [checked]="type.selected" class="inputValues">
                            </div>
                            <div class="itemData" title="{{type.name}}">{{type.name}}</div>
                        </div>

                    </div>

                </div>
                <div class="indexArea DN" [ngClass]="{'initialSelected': isIndexSelected}"
                    (click)="select('index',$event)">
                    <p style="width:100%;height:100%;text-align: center;padding-top:0.3rem">Index</p>
                </div>
            </div>
            <div class="dropdown-container">

                <div class="significanceDropdown" DocumentClick (DocumentClicked)="closeSignificance()"
                    *ngIf="sigConBaseToggle">
                    <div>Significance</div>
                    <div class="dd" (click)="onSignificanceDropdown()">
                        <p style="padding-top: 2.5%;padding-left: 7%;">{{displaySignificance}}</p>
                        <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': significanceDropdownToggle}"
                            style="top:23%"></div>
                    </div>
                    <div *ngIf="significanceDropdownToggle" class="b">
                        <div *ngFor="let item of significanceVal" class="dropdown-values"
                            (click)="significanceSelected1(item,$event)">

                            <div style="display:flex; width:100%;position:relative">
                                <div class="itemData" style="height:1.3rem" title="{{item.key}}"
                                    [ngClass]="{'selected-item': selectedSignificance === item}">
                                    <span style="padding-left:2%">{{item.key}}</span>
                                </div>
                                <div style="width:15%;display: flex;align-items: center;justify-content:end;position:absolute;left:85%;top:10%"
                                    *ngIf="item.key=='Reference'">
                                    <img src="../../../../assets/images/common/Right_Arrow.svg" alt=""
                                        class="rightIcon">
                                </div>

                            </div>
                            <div *ngIf="item.key=='Reference' && displayBrand" class="mainBrandDiv">
                                <div class="search-row-block" (click)="searchBoxClick($event)">
                                    <input type="text" [(ngModel)]="searchQuery" class="searchInput"
                                        placeholder="Search" />
                                    <div class="search-icon"></div>
                                </div>
                                <div style="height:9rem;overflow: auto;">
                                    <div *ngFor="let brand of allSigBrands| search : searchQuery : ['MetricOption'];let i = index"
                                        class="brandsDiv" (click)="brandSig(brand,$event)"
                                        [ngClass]="{'selected-item': selectedReference === brand}">
                                        <div style="padding-top:3%"><input type="radio" name="section"
                                                [value]="brand.key" [checked]="brand.isSelected" class="inputValues">
                                        </div>
                                        <div class="brandPara" style="padding-left:4%" title="{{brand.MetricOption}}">
                                            {{brand.MetricOption}}</div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>

                <!-- <div class="confidenceLeveldropdown DNN" (click)="onCLclick()" *ngIf="sigConBaseToggle">
                    <label for="myDropdownCL" class="dropdownCL">Confidence Level </label>
                    <select id="myDropdownCL" (change)="confidenceLevelSelected($event)"
                        [ngModel]="confidenceLevelSelectedValue">
                        <option *ngFor="let option of confidenceLevel" [value]="option.key"
                            [selected]="option.isSelected">{{option.key}}</option>
                    </select>
                </div> -->

                <div class="confidenceLeveldropdown DNN" (click)="onCLclick()" *ngIf="sigConBaseToggle">
                    <div>Confidence Level </div>
                    <div class="dd" (click)="onConfidenceLevelDropdown()">
                        <p style="padding-top: 2.5%;padding-left: 7%;">{{displayConfidenceLevel}}</p>
                        <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': ConfidenceLevelDropDownToggle}"
                            style="top:23%"></div>
                    </div>
                    <div *ngIf="ConfidenceLevelDropDownToggle" class="Confidence-level-dropdown">
                        <div *ngFor="let item of confidenceLevel" class="dropdown-values"
                            (click)="confidenceLevelSelected($event)">
                            <div style="display:flex; width:100%;position:relative">
                                <div class="itemData" style="height:1.3rem" title="{{item.key}}"
                                    [ngClass]="{'selected-item': displayConfidenceLevel === item.key}">
                                    <span style="padding-left:2%">{{item.key}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="referenceDropdownCSS" *ngIf="!sigConBaseToggle">
                    <div>Reference</div>
                    <div class="dd-ref" (click)="onReferenceDropdown()" DocumentClick
                        (DocumentClicked)="closeReferenceDropdown()">
                        <p class="brandDisplayDiv">{{displayReference}}</p>
                        <img src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg" alt="" class="icon">
                    </div>
                    <div *ngIf="referenceDropdownToggle" class="ref">
                        <div class="search-row-block" (click)="searchBoxClick($event)">
                            <input type="text" [(ngModel)]="searchQuery" class="searchInput" placeholder="Search" />
                            <div class="search-icon"></div>
                        </div>
                        <div style="height:10rem;overflow-y:auto ;">
                            <div *ngFor="let item of allbrands| search : searchQuery : ['MetricOption'];let i = index"
                                class="ref-dropdown-values" (click)="referenceSelected(item)"
                                [ngClass]="{'selected-item': selectedReference === item}">
                                <div style="padding-top:3%;width:13%"><input type="radio" name="section"
                                        [value]="item.MetricOption" [checked]="item.isSelected" class="inputValues">
                                </div>
                                <div class="brandPara" title="{{item.MetricOption}}">{{item.MetricOption}}</div>

                            </div>
                        </div>

                    </div>
                </div>

                <!-- <div class="baseDropdown">
                    <label for="myDropdownBase">Base </label>
                    <select class="base-dropdown" *ngIf="isAnswerBase" id="myDropdownBase" (change)="baseSelected($event)"
                        [ngModel]="baseLevelSelectedValue">
                        <option *ngFor="let option of base" [value]="option.key">{{option.key}}</option>
                    </select>
                    <select class="base-dropdown" *ngIf="!isAnswerBase" id="myDropdownBase" (change)="base2Selected($event)"
                        [ngModel]="baseLevelSelectedValue">
                        <option *ngFor="let option of base2" [value]="option.key">{{option.key}}</option>
                    </select>
                </div> -->

                <div class="baseDropdown">
                    <div>Base</div>
                    <div class="dd" (click)="onBaseDropdown()" DocumentClick (DocumentClicked)="closeBaseDropdown()">
                        <p style="padding-top: 2.5%;padding-left: 7%;">{{baseselected}}</p>
                        <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': BaseDropDownToggle}"
                            style="top:23%"></div>
                    </div>
                    <div *ngIf="BaseDropDownToggle && isAnswerBase" class="Base-dropdown"
                        [ngClass]="{'Index-Base-dropdown': isIndexSelected}">
                        <div *ngFor="let item of base; trackBy: trackByKey" class="dropdown-values" (click)="baseSelected($event)">
                            <div style="display:flex; width:100%;position:relative">
                                <div class="itemData" style="height:1.3rem" title="{{item.key}}"
                                    [ngClass]="{'selected-item': baseselected === item.key}">
                                    <span style="padding-left:2%">{{item.key}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="BaseDropDownToggle && !isAnswerBase" class="Base-dropdown"
                        [ngClass]="{'Index-Base-dropdown': isIndexSelected}">
                        <div *ngFor="let item of base2; trackBy: trackByKey" class="dropdown-values" (click)="base2Selected($event)">
                            <div style="display:flex; width:100%;position:relative">
                                <div class="itemData" style="height:1.3rem" title="{{item.key}}"
                                    [ngClass]="{'selected-item': baseselected === item.key}">
                                    <span style="padding-left:2%">{{item.key}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="weightDropdown" *ngIf="weight.length>1">
                    <label for="myDropdownBase">Weight </label>
                    <select id="myDropdownCL" (change)="weightSelected($event)"
                        [ngModel]="weightSelectedValue">
                        <option *ngFor="let option of weight" [value]="option.key"
                            [selected]="option.isSelected">{{option.key}}</option>
                    </select>
                </div> -->

                <div class="weightdropdownContainer" *ngIf="weight.length>1">
                    <div>Weight </div>
                    <div class="dd" (click)="onWeightDropdown()" DocumentClick
                        (DocumentClicked)="closeWeightDropdown()">
                        <p style="padding-top: 2.5%;padding-left: 7%;">{{weightSelectedValue}}</p>
                        <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': weightDropDownToggle}"
                            style="top:23%"></div>
                    </div>
                    <div *ngIf="weightDropDownToggle" class="weight-dropdown"
                        [ngClass]="{'Index-weight-dropdown': isIndexSelected}">
                        <div *ngFor="let item of weight" class="dropdown-values" (click)="weightSelected($event)">
                            <div style="display:flex; width:100%;position:relative">
                                <div class="itemData" style="height:1.3rem" title="{{item.key}}"
                                    [ngClass]="{'selected-item': weightSelectedValue === item.key}">
                                    <span style="padding-left:2%">{{item.key}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- //------------------------------------Index----------------------------------- -->

        </div>
        <!-- ------------------------------------------------- -->
        <div class="subSectionDiv">

        </div>
        <!-- ------------------------------------------------------- -->
        <div class="outputWidgetArea" style="width:100%;height:80%;" id="widget-display-div">
            <div *ngIf="showOutputView" style="width:100%;height:100%;">
                <ng-container *ngIf="page2Toggle==1">
                    <app-widget-outputview *ngIf="showOutput" style="height:100%;width:100%"
                        [baseSelected]="baseselected" [widgetInfo]="filteredWidgetSelection" [moduleLists]="moduleList"
                        [outputData]="outputData" [sortToggle]="sortToggle"
                        (paginationCounter)="paginationCounterFun($event)"></app-widget-outputview>
                </ng-container>

                <ng-container *ngIf="page2Toggle==2">
                    <app-widget-2-outputview *ngIf="showOutput" style="height:100%;width:100%"
                        [baseSelected]="baseselected" [widgetInfo]="filteredWidgetSelection" [moduleLists]="moduleList"
                        [outputData]="outputData" [sortToggle]="sortToggle"
                        (paginationCounter)="paginationCounterFun($event)"></app-widget-2-outputview>
                </ng-container>
            </div>
            <div style="display: flex; justify-content: center; align-items: center; height: 100%;"
                *ngIf="!showOutputView"> No data for current selections</div>
        </div>
        <!-- ---------------------------------------- -->
        <div class="outputFooterArea">
            <div style=" width: 40%;margin-right: 5%;">
                <div class="staticLsIsText">
                    <div>* - Indicates Low Base ({{LowBase}})</div>
                    <div><span style="font-weight: bold;">I/S</span> - Indicates Insufficient Base
                        ({{insufficientBase}})</div>
                    <div><span style="font-weight: bold;">NA</span> - Indicates Base = 0</div>

                </div>
                <div *ngIf="isIndexSelected" class="indexText" title="{{indexText}}">
                    Note: The indexed value greater than <span style="color:green">{{higherIndexValue}} are denoted by
                        green</span> and in <span style="color:red">Red for values less than {{lowerIndexValue}}</span>
                </div>

                <div *ngIf="isSigSelected && displaySignificance != 'None'" class="sigFooterText">
                    <span style="color:green; margin-left: 3%;">Significantly Higher</span>
                    <span style="color:red; margin-left: 12%;">Significantly Lower</span>
                </div>
            </div>

            <div [title]="stacticText" class="staticText"
                [ngClass]="{'statictext-justify-content': isIndexSelected ||(isSigSelected && displaySignificance != 'None')}">
                {{stacticText}}</div>
            <div class="saveSelection-btn config-footer-btn config-ftr" (click)="saveSelection()" [style]="showSaveSelectionButton?'display:flex':'display:none'"
                >
                <!-- [style]="showSaveSelectionButton?'display:flex':'display:none'" -->
                <!-- *ngIf="isSaveSelection" -->
                <div class="btn-icon save-icon"></div>
                <div class="btn-text">Save Selection</div>
            </div>
            <div class="sampleBtn " (click)="showSampleSizePopup()">Sample Size</div>
        </div>
    </div>
    <div class="no-data-screen DN"> Snapshot is not configured. Please contact Admin.</div>
</div>

<app-shared-popup-snapshot *ngIf="showSampleSizePop" [showSampleSizePopup]="showsamplesizepopup"
    [showInputPopUp]="false" [showErrorPopUp]="false" [popUpParameter]="'SampleSize'"
    [OutputdataObject]="OutputdataObject" [snapshotdata]="this.outputData" [isTranspose]="false" [isTotalBase]="true"
    [isAnswerBase]="false" [isSampleSize]="isSampleSize" [TrendToggleContainer]="TrendToggleContainer"
    [TrendToggleOn]="TrendToggleOn" (closeSamplesizePopUp)="onCloseIconClick($event)"></app-shared-popup-snapshot>

<app-shared-popup-snapshot *ngIf="showErrorPopUp" [popUpParameter]="errorheaderTitle" [errorheaderTitle]="popUpTitle"
    [popUpMessage]="popUpMessage" [showInputPopUp]="false" [buttonText]="buttonText"
    (closeErrorPopUp)="onCloseIconClick($event)" [showErrorPopUp]="showErrorPopUp"></app-shared-popup-snapshot>

<app-shared-popup-snapshot *ngIf="isLoadSelection && !isDefaultLoad"
    [loadUserDefinedSavedScenarioData]="loadUserDefinedSavedScenarioData"
    [loadSharedWithMeSavedScenarioData]="loadSharedWithMeSavedScenarioData" [popUpParameter]="errorheaderTitle"
    [errorheaderTitle]="popUpTitle" [popUpMessage]="popUpMessage" [showInputPopUp]="false" [buttonText]="buttonText"
    [isChangeOfEntryPointConfigured]="true" (isLoadClickOutput)="onCloseIconClick($event)" [showErrorPopUp]="false"
    [showLoadSelection]="isLoadSelection" (ShareSelectionClick)="ShareSelection($event)"
    (currentSavedScenarioData)="bindcurrentSavedScenarioData($event)" (deleteMessage)="bindDeleteMessage($event)"
    (isShowDialog)="updateShowDialog($event)"
    (bindSelectedScenario)="bindSelectedScenario($event)"></app-shared-popup-snapshot>

<app-confirmation-dialog id="deleteConfirmation" *ngIf="isShowDialog" [messageText]="deleteMessage"
    (confirmed)="onConfirmation($event)"></app-confirmation-dialog>

<app-shared-popup-snapshot *ngIf="isShareSelectionClick" [shareSelectionUserList]="shareSelectionUserList"
    [showLoaderPopUp]="showLoaderPopUp" [selectedEmailsToShare]="selectedEmailsToShare"
    [selectedLoadSelectionObj]="selectedLoadSelectionObj" [isShareSelectionClick]="isShareSelectionClick"
    (isShareSelectionVisible)="handleShareSelectionPopUp($event)"
    (SaveSelectionClick)="SaveSelection($event)"></app-shared-popup-snapshot>


<app-shared-popup-snapshot *ngIf="isSaveSelectionClick" [showInputPopUp]="false" [showErrorPopUp]="false"
    [isSaveSelectionClick]="isSaveSelectionClick" [showLoaderPopUp]="showSaveSelectionPopup"
    [popUpParameter]="errorheaderTitle" (isSavePopUpVisible)="handleSavePopUP($event)"
    (SaveSelectionClick)="SaveSelection($event)"></app-shared-popup-snapshot>